import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import ContactForm from "./functions/ContactForm";
import { Link } from "react-router-dom";

const Footer = () => {
	return (
		<footer className="bg-black text-white overflow-hidden">
			<div className="flex flex-col gap-10 justify-around items-center text-center lg:flex-row">
				<ContactForm />
				<ul className="flex flex-col font-cairo font-bold">
					<li className="underline text-2xl text-zinc-700 ">
						{" "}
						<Link to="/gallery"> أطفال الأقصى </Link>
					</li>
					<li className="underline text-2xl text-zinc-700 ">
						{" "}
						<Link to="/gallery"> سيارات </Link>
					</li>
					<li className="underline text-2xl text-zinc-700 ">
						{" "}
						<Link to="/gallery"> احياء القدس </Link>
					</li>
					<li className="underline text-2xl text-zinc-700 ">
						{" "}
						<Link to="/gallery">صور ليلية</Link>
					</li>
				</ul>
				<ul dir="ltr" className="flex flex-col font-cairo place-content-center">
					<li className="my-2 place-self-center lg:place-self-start">
						<img className="w-[100px]" src="./assets/dbrand-logo.png" alt="" />
					</li>
					<li className="my-2 place-self-center lg:place-self-start">
						<a href="tel:+972542851590">
							<FontAwesomeIcon icon={faPhone} style={{ color: "#1cb822", width: "25px", height: "25px" }} /> -{" "}
							<span className="underline">+972 54 285 1590</span>
						</a>
					</li>
					<li className="my-2 place-self-center lg:place-self-start">
						<a rel="noreferrer" target={"_blank"} href="https://www.instagram.com/issam._.al_ashhab">
							<img className="inline-block" src="./assets/insta-logo.png" alt="" /> - <span className="underline">Instagram</span>
						</a>
					</li>
					<li className="my-2 place-self-center lg:place-self-start">
						<a rel="noreferrer" target={"_blank"} href="https://t.me/issam_alashhab">
							<img className="inline-block" src="./assets/telegram-logo.png" alt="" /> - <span className="underline">Telegram</span>
						</a>
					</li>
					<li className="my-2 place-self-center lg:place-self-start">
						<a rel="noreferrer" target={"_blank"} href="mailto:">
							<img className="inline-block" src="./assets/mail-logo.png" alt="" /> - <span className="underline">Gmail</span>
						</a>
					</li>
				</ul>
			</div>
		</footer>
	);
};

export default Footer;
